import { createContext, useContext } from "react";
import { ICharacteristicsContext } from "./types";

export const CharacteristicsContext = createContext<ICharacteristicsContext | null>(null);

export const useCharacteristicsContext = () => {
  const context = useContext(CharacteristicsContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
